import React from 'react';

// Official monochrome brand glyph (the assets in /assets/images/platforms/)
// rendered through a CSS mask filled with currentColor, so it behaves exactly
// like an inline SVG did: it inherits the text color, picks up hover tints,
// and stays visible on any background. Rendering the PNG directly would pin
// the glyph to black.
const BrandGlyph = ({ src, className = 'w-4 h-4' }) => (
  <span
    aria-hidden="true"
    className={`inline-block flex-shrink-0 ${className}`}
    style={{
      backgroundColor: 'currentColor',
      WebkitMaskImage: `url(${src})`,
      maskImage: `url(${src})`,
      WebkitMaskSize: 'contain',
      maskSize: 'contain',
      WebkitMaskRepeat: 'no-repeat',
      maskRepeat: 'no-repeat',
      WebkitMaskPosition: 'center',
      maskPosition: 'center',
    }}
  />
);

export default BrandGlyph;
